export const ERROR_STATUS = {
    NOT_FOUND_PAYMENT_ID: 404,
    SOMETHING_WENT_WRONG: 500
};

export const PAYMENT_STATUS = {
    DONE: 'Done',
    PENDING: 'Pending'
};
